import OrderDetails from './order-details';
import CompleteOrderModal from './CompleteOrderModal';
import CreateRefundModal from './CreateRefundModal';
import RejectOrderModal from './RejectOrderModal';

export default {
  OrderDetails,
  CompleteOrderModal,
  CreateRefundModal,
  RejectOrderModal,
};
